import Swiper                 from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

const sliders = () => {
    const slidersLoop = document.querySelectorAll('[data-slider="loop"]');
    slidersLoop.forEach((el) => {
        const sliderNav = el.dataset.nav;
        const sliders   = new Swiper(el, {
            modules       : [Navigation],
            slidesPerView : 'auto',
            spaceBetween  : 20,
            loop          : false,
            speed         : 500,
            navigation    : {
                prevEl : `[data-prev="${sliderNav}"]`,
                nextEl : `[data-next="${sliderNav}"]`
            }

        });
    });

    const slidersPost = document.querySelectorAll('[data-slider="reviews"]');
    slidersPost.forEach((el) => {
        const sliderNav = el.dataset.nav;
        const sliders   = new Swiper(el, {
            modules: [Autoplay],
            slidesPerView: 'auto',
            spaceBetween: 12,
            loop: true,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
            },
            speed: 4500,
            breakpoints: {
                1081: {
                    direction: "vertical",
                    slidesPerView: 7,
                }
            }

        });
    });

    const slidersLine = document.querySelectorAll('[data-slider="line"]');
    slidersLine.forEach((el) => {
        const sliders   = new Swiper(el, {
            modules: [Autoplay],
            slidesPerView: 'auto',
            spaceBetween: 12,
            loop: true,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
            },
            speed: 4500,

        });
    });
};
export default sliders;
